import React from 'react'
//var DatePicker = require("reactstrap-date-picker");
// instalation is needed => npm install reactstrap-date-picker
// <DatePicker />
export default function CloseDay() {
    return (
        <div>
            
        </div>
    )
}
